import { isAxiosError } from "axios";
import { isRouteErrorResponse } from "react-router-dom";

const SERVICE_UNAVAILABLE_STATUSES = [502, 503, 504] as const;

type ErrorWithCode = {
  code?: string;
};

export function getErrorStatus(error: unknown): number | undefined {
  if (isAxiosError(error)) {
    return error.response?.status;
  }

  if (isRouteErrorResponse(error)) {
    return error.status;
  }

  return undefined;
}

export function isBackendUnavailableError(error: unknown): boolean {
  if (isAxiosError(error)) {
    if (error.code === "ERR_CANCELED") {
      return false;
    }

    if (!error.response) {
      return true;
    }

    return SERVICE_UNAVAILABLE_STATUSES.includes(
      error.response.status as (typeof SERVICE_UNAVAILABLE_STATUSES)[number],
    );
  }

  if (isRouteErrorResponse(error)) {
    return SERVICE_UNAVAILABLE_STATUSES.includes(
      error.status as (typeof SERVICE_UNAVAILABLE_STATUSES)[number],
    );
  }

  const code = (error as ErrorWithCode | undefined)?.code;
  return code === "ERR_NETWORK";
}
